import { makeVar } from "@apollo/client";

import type { TGraphQLError } from "settings/apollo/types";

export enum ExternalSessionLossEnum {
  Unauthorized = "UNAUTHORIZED",
  NotFound = "NOT_FOUND",
}

/**
 * Set by the external client's error link when a request proves the OTP session is gone, read by
 * `ExternalSessionGuard` to send the agent back to the access code.
 */
export const externalSessionLossVar = makeVar<ExternalSessionLossEnum | null>(null);

/**
 * Whether an external API error means the OTP session is gone. A mutation's not_found may only mean the
 * resource stopped accepting writes, so the page refetches it first and lets that query decide.
 */
export const getExternalSessionLoss = (error: TGraphQLError, isQuery: boolean): ExternalSessionLossEnum | null => {
  if (error.code === "UNAUTHORIZED") {
    return ExternalSessionLossEnum.Unauthorized;
  }

  if (isQuery && error.code === "NOT_FOUND") {
    return ExternalSessionLossEnum.NotFound;
  }

  return null;
};
